import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { GlobalStyle } from "styles/global-styles";
import { withTranslation } from "react-i18next";
import { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import LoadingPage from "pages/Loading";
import UnderConstruction from "pages/UnderConstruction";
import Navigation from "components/Nav";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { autoConnectEthereumProvider } from "services/wallet";

const LandingPage = React.lazy(() => import("pages/Landing"));
const DiamondPage = React.lazy(() => import("pages/DiamondHand"));

const AppContentWrapper = styled.div`
  margin: 2rem 12rem;

  @media (max-width: 1300px) {
    margin: 2rem;
  }

  @media (max-width: 320px) {
    margin: 0.5rem;
  }
`;

export interface IAppContent {
  element: React.ReactNode;
}

const AppContent = ({ element }: IAppContent) => {
  return <AppContentWrapper>{element}</AppContentWrapper>;
};

function App() {
  const { i18n } = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    autoConnectEthereumProvider(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet
        titleTemplate="Sappchat"
        defaultTitle="Sappchat"
        htmlAttributes={{ lang: i18n.language }}
      >
        <meta name="description" content="Sappchat" />
      </Helmet>

      <Suspense fallback={<LoadingPage />}>
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route
              path="/"
              //element={<AppContent element={<LandingPage />} />} //TODO: uncomment this and delete next line
              element={<AppContent element={<DiamondPage />} />}
            />
            {/* Initially this was Diamond Hand -- owner asked to change name after delivery, too much hassle to change code, so ...*/}
            <Route
              path="/hodlapp"
              element={<AppContent element={<DiamondPage />} />}
            />
            <Route path="*" element={<UnderConstruction />} />
          </Routes>
        </BrowserRouter>
      </Suspense>

      <GlobalStyle />
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        closeOnClick
        pauseOnHover
      />
    </>
  );
}

export default withTranslation()(App);
